import { useState, useEffect } from 'react';

// Proxies logo through /api/logo to stay within CSP connect-src 'self'; suppresses WebView no-cache
export default function useCachedLogo(logoUrl) {
  const [logoSrc, setLogoSrc] = useState(null);

  useEffect(() => {
    if (!logoUrl) {
      setLogoSrc(null);
      return;
    }

    let objectUrl = null;
    let cancelled = false;

    const proxied = `/api/logo?url=${encodeURIComponent(logoUrl)}`;
    fetch(proxied, { cache: 'force-cache' })
      .then(response => (response.ok ? response.blob() : Promise.reject()))
      .then(blob => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setLogoSrc(objectUrl);
      })
      .catch(() => {
        if (!cancelled) setLogoSrc(logoUrl);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [logoUrl]);

  return logoSrc;
}
